import Axios from 'axios'
import { bookingSearchUrls } from '../urls'
import router from '../../../router'

export default {
  search_booking_by_key(context, data) {
    Axios.post(bookingSearchUrls.searchByKey, data).then(function (response) {
      context.commit('GET_ALL_BOOKINGS', response.data)
    }).catch(function (error) {
      // console.log(error.data)
    })
  },
  search_booking_by_key_report(context, data) {
    Axios.post(bookingSearchUrls.searchByKeyReport, data).then(function (response) {
      context.commit('GET_ALL_BOOKINGS_REPORT', response.data)
    }).catch(function (error) {
      // console.log(error.data)
    })
  },
  search_inspect_booking_by_key(context, data) {
    Axios.post(bookingSearchUrls.searchByKeyInspect, data).then(function (response) {
      context.commit('GET_INSPECTION_BOOKINGS_TODAY', response.data)
    }).catch(function (error) {
      
      // console.log(error.data)
    })
  },
  search_inspected_alerted_bookings(context, data) {
    Axios.post(bookingSearchUrls.searchInspectedAlertedBookings, data).then(function (response) {
      context.commit('GET_INSPECTED_ALERTED_BOOKINGS', response.data)
    }).catch(function (error) {
      // context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },

  search_unticketed_alerted_bookings(context, data) {
    Axios.post(bookingSearchUrls.searchUnticketedAlertedBookings, data).then(function (response) {
      context.commit('GET_INSPECTED_UNTICKETED_ALERTED_BOOKINGS', response.data)
    }).catch(function (error) {
      // context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  search_proofed_bookings(context, data) {
    Axios.post(bookingSearchUrls.searchProofedBookings, data).then(function (response) {
      context.commit('GET_BOOKINGS_RESIDENCY_PROOF', response.data)
    }).catch(function (error) {
      // context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  search_partner_booking_by_key(context, data) {
    Axios.post(bookingSearchUrls.searchByKeyPartner, data).then(function (response) {
      context.commit('GET_PARTNER_BOOKINGS', response.data)
    }).catch(function (error) {
      // console.log(error.data)
    })
  },
  search_booking_by_date(context, data) {
    Axios.post(bookingSearchUrls.searchBySingleDate, data).then(function () {
      context.dispatch('get_all_starts')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {

    })
  },
  search_checked_in_by_date_range(context, data) {
    Axios.post(bookingSearchUrls.searchCheckInByDateRange, data).then(function (response) {
      context.commit('GET_ALL_BOOKINGS', response.data)
    }).catch(function (error) {
      // context.commit('UPDATE_ERRORS', error.data)
      console.log(error.data)
    })
  },
  search_checked_in_by_date_range_report(context, data) {
    Axios.post(bookingSearchUrls.searchCheckInByDateRangeReport, data).then(function (response) {
      context.commit('GET_ALL_BOOKINGS_REPORT', response.data)
    }).catch(function (error) {
      // context.commit('UPDATE_ERRORS', error.data)
      console.log(error.data)
    })
  },
  search_partner_booking_by_date_range(context, data) {
    Axios.post(bookingSearchUrls.searchPartnerCheckInByDateRange, data).then(function (response) {
      context.commit('GET_PARTNER_BOOKINGS', response.data)
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  search_checked_out_by_date_range(context, data) {
    Axios.post(bookingSearchUrls.searchCheckOutByDateRange, data).then(function () {
      context.dispatch('get_all_starts')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      // console.log(error.data)
    })
  },
  search_booking_payments_by_key(context, data) {
    Axios.post(bookingSearchUrls.searchPaymentsByKey, data).then(function (response) {
      context.commit('GET_SEARCH_BOOKING_PAYMENTS', response.data)
    }).catch(function (error) {
      // console.log(error.data)
    })
  },
  search_booking_payments_by_date_range(context, data) {
    Axios.post(bookingSearchUrls.searchPaymentsByDateRange, data).then(function (response) {
      context.commit('GET_SEARCH_BOOKING_PAYMENTS', response.data)
    }).catch(function (error) {
      // context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  search_booking_bankslip_by_key(context, data) {
    Axios.post(bookingSearchUrls.searchBankSlipByKey, data).then(function (response) {
      context.commit('GET_BANK_SLIP_DATA', response.data)
    }).catch(function (error) {
      // console.log(error.data)
    })
  },
  search_bankSlip_by_date_range(context, data) {
    Axios.post(bookingSearchUrls.searchBankSlipByDateRange, data).then(function (response) {
      context.commit('GET_BANK_SLIP_DATA', response.data)
    }).catch(function (error) {
      // context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
}
